module.exports = __webpack_public_path__ + "img/4.86a0361c.gif";